import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { optInToTracking, optOutOfTracking, hasMadeChoice } from '../lib/posthog';

const texts = {
  de: {
    title: 'Cookies & Datenschutz',
    message:
      'Wir verwenden Cookies, um die Nutzung unserer Website zu analysieren und zu verbessern. Sie können selbst entscheiden, ob Sie dies erlauben möchten.',
    accept: 'Akzeptieren',
    decline: 'Ablehnen',
    privacy: 'Datenschutzerklärung',
  },
  en: {
    title: 'Cookies & Privacy',
    message:
      'We use cookies to analyse and improve the use of our website. You can decide for yourself whether you want to allow this.',
    accept: 'Accept',
    decline: 'Decline',
    privacy: 'Privacy Policy',
  },
};

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const { language } = useLanguage();

  useEffect(() => {
    if (!hasMadeChoice()) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    optInToTracking();
    setVisible(false);
  };

  const handleDecline = () => {
    optOutOfTracking();
    setVisible(false);
  };

  if (!visible) return null;

  const tx = texts[language] || texts.de;
  const privacyHref = language === 'en' ? '/privacy' : '/datenschutz';

  // Spezialfall (R3.1): Consent-Banner nutzt bewusst Inline-Styles (unabhängig
  // vom App-CSS). Hexwerte entsprechen den v2-Tokens (ink #0F172A, brand #FF7A3D).
  return (
    <div
      role="dialog"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-description"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#0F172A',
        color: '#fff',
        padding: '1.5rem',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
        zIndex: 9999,
        borderTop: '2px solid #FF7A3D',
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <div>
          <h3 id="cookie-banner-title" style={{ margin: '0 0 0.5rem 0', fontSize: '1.1rem' }}>
            {tx.title}
          </h3>
          <p
            id="cookie-banner-description"
            style={{ margin: 0, fontSize: '0.9rem', lineHeight: '1.5' }}
          >
            {tx.message}{' '}
            <Link to={privacyHref} style={{ color: '#FF7A3D', textDecoration: 'underline' }}>
              {tx.privacy}
            </Link>
          </p>
        </div>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <button
            onClick={handleAccept}
            style={{
              backgroundColor: '#FF7A3D',
              color: '#fff',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: '0.9rem',
            }}
          >
            {tx.accept}
          </button>
          <button
            onClick={handleDecline}
            style={{
              backgroundColor: 'transparent',
              color: '#fff',
              border: '1px solid #555',
              padding: '0.75rem 1.5rem',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: '0.9rem',
            }}
          >
            {tx.decline}
          </button>
        </div>
      </div>
    </div>
  );
}
